import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import useGetParameter from 'hooks/useGetParameter';
import Login from 'components/Login';
import ForgotPassword from 'components/ForgotPassword';
import ResetPassword from 'components/ResetPassword';
import SignUp from 'components/SignUp';
import EmailConfirmation from 'components/EmailConfirmation';
import { GET_ENUMS } from './const/router';

const popups = {
  [GET_ENUMS.popup.login]: Login,
  [GET_ENUMS.popup.forgotPassword]: ForgotPassword,
  [GET_ENUMS.popup.resetPassword]: ResetPassword,
  [GET_ENUMS.popup.signUp]: SignUp,
  [GET_ENUMS.popup.emailConfirmed]: EmailConfirmation,
};

const PopupManager = () => {
  const popupName = useGetParameter('popup');
  const history = useHistory();
  const { pathname } = useLocation();

  const Component = popups[popupName];

  if (!Component) {
    return null;
  }

  return <Component onClose={() => history.push(pathname)} />;
};

export default PopupManager;



// WEBPACK FOOTER //
// ./src/PopupManager.js